import { makeAutoObservable } from 'mobx';
import {successAlert, openFileStack} from 'shared/tools';
import Candidate from 'main/stores/recruiting/Candidate';
import CandidateViewModel from 'main/containers/recruiting/state/CandidateViewModel';
import {t} from 'shared/core';
import {types, endpoints} from 'main/tools';
import Answer from 'main/stores/recruiting/Answer';
import recruitingStore from 'main/stores/recruiting/RecruitingStore';

class ReferralFormState {
  store = recruitingStore;
  history;
  match;

  candidateViewModel = new CandidateViewModel(new Candidate());
  errors = {};
  submitted = false;
  position;
  isUploading = false;

  constructor() {
    makeAutoObservable(this, {
      store: false,
      history: false
    });
  }

  receiveProps({history, match}) {
    this.history = history;
    this.match = match;
  }

  async load() {
    this.position = await this.store.loadSingle(this.match.params.id);

    for (const question of this.position.questions) {
      this.candidate.answers.push(new Answer({question: question}));
    }
  }

  onUploadStarted() {
    this.isUploading = true;
  }

  onUploadFinished() {
    this.isUploading = false;
  }

  calculateQuestionRequired() {
    return false;
  }

  async createCandidate() {
    const {errors, model} = await this.store.post(
      endpoints.RECRUITING.CANDIDATES.REFER.with(this.match.params.id),
      types.RECRUITING.CANDIDATE,
      this.candidate
    );

    if (model) {
      this.history.goBack();
      successAlert(t('referrals.referral_form.Referral successfully submitted'));
    }
    this.errors = errors;
  }

  get candidate() {
    return this.candidateViewModel.candidate;
  }

  uploadFileForAnswer(answer) {
    openFileStack({
      storeTo: { path: 'resumes/' }
    }, file => answer.merge({attachment: file}));
  }
}

export default ReferralFormState;
